import styled from 'styled-components';

import ProductImageComponent from '@prisjakt/ui-product-image';
import { layout } from '@prisjakt/ui-base';
import RatingComponent from '@prisjakt/ui-rating';

const imageSize = '40px';
const padding = layout.spacing.xSmall;

export const ProductRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${padding};
`;

export const ProductImage = styled(ProductImageComponent)`
  max-width: ${imageSize};
  margin-right: ${padding};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;

export const EditControls = styled.div`
  position: absolute;
  top: ${padding};
  right: ${padding};
`;

export const Name = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: ${p => p.theme.text.primary};
  margin-right: 30px; /* Dont overlap edit button */
`;

export const Subtitle = styled.div`
  color: ${p => p.theme.text.secondary};
  font-size: ${layout.fontSizes.small.desktop.rem};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 30px; /* Dont overlap edit button */
`;

type BottomRowProps = {
  row: boolean;
};

export const BottomRow = styled.div<BottomRowProps>`
  display: flex;
  flex-direction: ${p => (p.row ? 'row' : 'column')};
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

type PriceProps = {
  type:
    | 'AlertProduct'
    | 'ListProduct'
    | 'AlertSearch'
    | 'ListSearch'
    | 'ListCategory';
  rating: boolean;
};

export const Price = styled.div<PriceProps>`
  width: 100%;
  margin-right: ${p => (!p.rating && p.type === 'ListProduct' ? 'auto' : 0)};
`;

export const Rating = styled(RatingComponent)`
  margin-right: auto;
`;
